import {OperationalEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateResult} from "../view-model";

export const toInProgressResult = (
  newEntity: OperationalEntity
): CreateResult => {
  return {
    status: "in-progress",
    caId: newEntity.sources[0].sourceId,
    dbaName: newEntity.organizationInformation.dbaName
  };
};
